import { render, staticRenderFns } from "./ImagePopup.vue?vue&type=template&id=5f4be45e&"
import script from "./ImagePopup.vue?vue&type=script&lang=ts&"
export * from "./ImagePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports